import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const ROW_VARIANTS = {
  standard: "standard",
  large: "large",
}

const Summary = ({ summaryTotals, presentmentCurrency }) => {
  const { totalCents, paidCents, unpaidCents, dueNowCents } = summaryTotals

  const renderLabel = (label, variant) => (
    <div
      className={classNames("text-nowrap font-semibold", {
        "!text-lg font-bold": variant === ROW_VARIANTS.large,
      })}
    >
      {label}
    </div>
  )

  const renderValue = (label, value, variant) => {
    const labelForTestId = label.toLowerCase().replace(/\s/g, "-")

    return (
      <div
        data-testid={`print-view-summary-${labelForTestId}-value`}
        className={classNames("break-all", {
          "!text-lg font-bold !text-red-600": variant === ROW_VARIANTS.large,
        })}
      >
        {formatCurrencyFromMinorUnits({
          amount: value,
          currency: presentmentCurrency,
        })}
      </div>
    )
  }

  const renderSummaryLine = ({
    label,
    value,
    variant = ROW_VARIANTS.standard,
  }) => (
    <>
      {renderLabel(label, variant)}
      {renderValue(label, value, variant)}
    </>
  )

  return (
    <div
      className="grid w-fit max-w-96 grid-cols-2 gap-x-8 gap-y-1 !bg-gray-200 p-4"
      data-testid="print-view-summary"
    >
      {renderSummaryLine({ label: "TOTAL", value: totalCents })}
      {renderSummaryLine({ label: "PAID", value: paidCents })}
      {renderSummaryLine({ label: "UNPAID", value: unpaidCents })}
      <div className="col-span-2 pt-4" />
      {renderSummaryLine({
        label: "DUE NOW",
        value: dueNowCents,
        variant: ROW_VARIANTS.large,
      })}
    </div>
  )
}

Summary.propTypes = {
  summaryTotals: PropTypes.shape({
    totalCents: PropTypes.number.isRequired,
    paidCents: PropTypes.number.isRequired,
    unpaidCents: PropTypes.number.isRequired,
    dueNowCents: PropTypes.number.isRequired,
  }).isRequired,
  presentmentCurrency: PropTypes.string.isRequired,
}

export default Summary
